import { render } from "./editor.vue?vue&type=template&id=e203ad64"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"

import "./editor.vue?vue&type=style&index=0&id=e203ad64&lang=scss"

import exportComponent from "/opt/compla/docker/sites/my-atw-global/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__